<template>
  <div class="multimedia-record" :data-src="record.url || record.serverId">
    <div class="control">
      <img
        class="play-icon"
        src="./img/1.png"
        v-if="!isplaying"
        @click="play"
      />
      <img class="play-icon" src="./img/2.png" v-else @click="stopPlay" />
    </div>

    <div class="progress-group">
      <div class="progress-bar"></div>
      <div class="progress-play" :style="{ width: percent }"></div>
      <!-- <div class="progress-ball" :style="{'left': percent}"></div> -->
    </div>

    <div class="time-tip">{{ playTime }}</div>
  </div>
</template>

<script>
import { computed, inject, ref, onUnmounted } from 'vue';
import v from './v';
/**
 * 接收的语音对象示例(如下两种都可以)
 * 1. 本地录制的语音
 * {
 *     localId: "",
 *     duration: 10
 * }
 *
 * 2.
 * {
 *     name: 名字
 *     size: 大小, 单位byte
 *     md5: md5
 *     url: url
 *     extension: 扩展名
 *     duration: 长度, 单位ms
 * }
 *
 */

export default {
  name: 'multimedia-record',
  props: {
    value: String,
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const $message = inject('$message');
    const isplaying = ref(false);
    const lastTime = ref(props.record.duration);
    const timer = ref(null);
    const interFns = {
      // 语音加载中....
      onloading() {
        isplaying.value = false;
      },
      // 语音开始播放....
      onplaying() {
        isplaying.value = true;

        const interval = 40;

        // 定时器的指向
        timer.value = setInterval(() => {
          // this.lastTime -= interval;
          lastTime.value -= interval / 1000;

          if (lastTime.value <= 0) {
            lastTime.value = 0;
            clearInterval(timer.value);
          }
        }, interval);
      },
      // 回到默认状态...
      ondefault() {
        clearInterval(timer.value);
        lastTime.value = props.record.duration;
        isplaying.value = false;
      },
    };

    onUnmounted(() => {
      v.stop();
    });

    return {
      isplaying,
      lastTime,
      playTime: computed(() => {
        // 先将豪秒数转换成秒数
        // let second = this.lastTime / 1000,
        const second = lastTime.value;
        const dur = Math.ceil(second);
        let s = dur % 60;
        let m = Math.floor((dur % 3600) / 60);
        let h = Math.floor(dur / 3600);
        function addZero(n) {
          if (n < 0) {
            return `0${s}`;
          }
          return n;
        }
        s = addZero(s);
        m = addZero(m);
        h = addZero(h);

        if (dur < 3600) {
          return `${m}:${s}`;
        }
        return `${h}:${m}:${s}`;
      }),
      percent: computed(() => `${(1 - lastTime.value / props.record.duration) * 100}%`),
      play() {
        if (!props.record.url) {
          $message.error('暂不支持播放该语音');
        } else {
          const opt = {
            loading: interFns.onloading,
            playing: interFns.onplaying,
            end: interFns.ondefault,
            endAuto: interFns.ondefault,
            error: interFns.ondefault,
          };
          v.play(props.record, opt);
        }
      },
      stopPlay() {
        v.stop();
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.multimedia-record {
  height: 38px;
  line-height: 38px;
  background-color: rgba(35, 131, 254, 0.08);
  border-radius: 100px;
  // border: 1px solid #eee;
  display: flex;
  align-items: center;
  max-width: 220px;
  .control {
    padding-left: 12px;
    padding-right: 12px;
    .play-icon {
      // font-size: 30px;
      width: 22px;
      height: 22px;
      display: block;
      // vertical-align: middle;
    }
  }
  .progress-group {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    .progress-bar {
      position: absolute;
      height: 2px;
      background-color: rgba(35, 131, 254, 0.28);
      width: 100%;
    }
    .progress-play {
      position: absolute;
      height: 2px;
      width: 0;
      background-color: #1e88f5;
    }
    .progress-ball {
      position: absolute;
      left: 0;
      width: 10px;
      height: 10px;
      margin-left: -5px;
      background-color: #1e88f5;
      border-radius: 10px;
    }
  }
  .time-tip {
    padding-left: 20px;
    padding-right: 14px;
    font-size: 12px;
    color: #1e88f5;
  }
}
</style>
